import { render, staticRenderFns } from "./part-g.vue?vue&type=template&id=47527260&"
import script from "./part-g.vue?vue&type=script&lang=js&"
export * from "./part-g.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports